import type { FaireProductEntity } from "../../entity_types/product";

export const p_p97k4v76e3: FaireProductEntity = {
  token: "p_p97k4v76e3",
  type: "product",
  name: "Sensory Suds™ Bubble Bath",
  brandToken: "b_2vgr3yu7bj",
  brandName: "Dabble & Dollop®",
  imageUrl:
    "https://cdn.faire.com/fastly/613ebf79530b0f97f7d30b98edbcb59084ae886ac68da5856c16af67ccbdccbe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/feca9aa0bdbce6aad5dda718b23ed329660edcf701017d5e6d61f2806e525542.png",
    "https://cdn.faire.com/fastly/c78029b2d4be0e9c7c9367f1306272a7b26e8303a293e707a4a32c8ad0aa9141.png",
    "https://cdn.faire.com/fastly/90d53a434efb47023458cc76bdd1899e862d57248c09da1d0a388b995672a25c.jpeg",
    "https://cdn.faire.com/fastly/159564d77b32854f9cf6ea1585c997815bdcf7e353c082f009c2c8b352d6d7e2.jpeg",
  ],
  priceDollars: 9.57,
  description:
    "Our NEW EWG-Verified Sensory Suds™ Bubble Bath creates soft, gentle bubbles that transform bath time into a soothing sensory ritual for baby. With only 10 natural origin ingredients, this fragrance-free formula is carefully crafted to protect baby’s fragile skin barrier while delivering just-right bubbles.\n\nInfused with chamomile extract and formulated at pH 5.5, Sensory Suds™ supports baby's delicate skin and helps maintain hydration without irritation. Tear-free and microbiome-friendly, it’s designed for peace of mind and joyful bonding moments in the bath.",
  tags: [],
  msrpDollars: 19.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:47.955Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
